module.exports = __webpack_public_path__ + "media/images/jlp-jobs-map-lg-680363f06b7b01d22369271e729a8cda.png";